<template>
    <div class="column registration-place mx-4 mt-4">
        <form @submit.prevent class="form">

            <div class="field ">
                <label class="label is-sr-only">Number Plate Registration</label>
                <div class="control">
                    <input 
                        v-model="registration"
                        maxlength="12"
                        class="input number-plate" type="text" placeholder="ADD REG"
                    >
                </div>
            </div>
            
            <div class="field">
                
                <div class="control">
                    <button 
                        @click="startUpdateRegistration"
                        :class="{'is-loading':is_loading || !current_user}"
                        class="button is-primary is-massive has-text-weight-bold is-fullwidth-mobile">
                        NOMINATE
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import { mapGetters,mapActions } from "vuex";
export default {
    data() {
        return {
            registration: '',
        }
    },     
    computed: {
        ...mapGetters({
            is_loading: "is_loading",
            current_user: "current_user"
        }),
    },
    methods: {
        ...mapActions({
            updateRegistration: "updateRegistration",
            loading: "loading"
        }),
        startSubmitRegistration() {
            this.loading(true)
            this.submitRegistration(this.registration).then(()=>{
            }).catch(()=>{
                this.loading(false)
            })
        },
        startUpdateRegistration() {
            this.loading(true)
            var submission = { 
                number_plate: this.registration,
                next_path: '/additional/' + this.registration, 
                on_error: {text: "Type in a car registration in the number plate below", type:'is-danger'} ,
                details: {
                    submitted_at: new Date().getTime() 
                }
            }
            this.updateRegistration(submission).then(()=>{
                
            }).catch(()=>{
                this.loading(false)
            })
        }
    }
}
</script>

